import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getDataPersonal } from '../../../actions/webAfiliado/afiliadoVariosAction'
import { startAlerta } from '../../../actions/ui/alertas'
import { finishSpinner, startSpinner } from '../../../actions/ui/spinner'
import LoadingBeforeViewData from '../../compartidos/LoadingBeforeViewData'
import MiPerfil from './MiPerfil'
import AfiliadoService from '../../../services/AfiliadoService'
import { useHistory, useParams } from 'react-router-dom'

const MiPerfilContainer = (props) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const {idAfiliado: idAfiliadoTurno} = useParams();
    const { idUsuario, idAfiliado } = useSelector(state => state.auth)
    const { dataAfiliado } = useSelector(state => state.afiliadoVarios)

    const handleResetPassword = async (data, resetPass) => {
        try {
            dispatch(startSpinner())
            const result = await AfiliadoService.cambiarPasswordUser(data)
            const body = await result.json()
            if (result.ok) {
                dispatch(finishSpinner())
                resetPass()
                dispatch(startAlerta("¡Contraseña actualizada exitosamente!", "success"))
            } else {
                throw body.errores
            }
        } catch (error) {
            dispatch(finishSpinner())
            if (error.mensaje) {
                dispatch(startAlerta(error.mensaje, "error"))
            } else {
                dispatch(startAlerta("Ha ocurrido un error en el cambio de contraseña. Intente nuevamente.", "error"))
            }
            console.log("Error en el cambio de contraseña del usuario", error)
        }
    }

    const handleChangeDataContacto = async (data) => {
        try {
            dispatch(startSpinner())
            data.idAfiliado=idAfiliadoTurno ? idAfiliadoTurno : idAfiliado;
            const result = await AfiliadoService.cambiarDataAfiliado(data)
            const body = await result.json()
            if (result.ok) {
                dispatch(finishSpinner())
                dispatch(startAlerta("¡Datos de contacto actualizados exitosamente!", "success"))
                if(idAfiliadoTurno){
                    if(props.location.state?.from !== "/afiliado/discapacidad")
                        history.push("/afiliado/turnos/sacar-turno")
                    else
                        history.push("/afiliado/discapacidad/nueva-solicitud")
                }
            } else {
                throw body.errores
            }
        } catch (error) {
            dispatch(finishSpinner())
            if (error.mensaje) {
                dispatch(startAlerta(error.mensaje, "error"))
            } else {
                dispatch(startAlerta("Ha ocurrido un error en el cambio de datos de contacto. Intente nuevamente.", "error"))
            }
            console.log("Error en el cambio de cambio de datos del usuario", error)
        }
    }

    useEffect(()=>{
        dispatch(getDataPersonal(idAfiliadoTurno ? idAfiliadoTurno : idAfiliado))
        // eslint-disable-next-line
    }, [])

    if(dataAfiliado === null){
        return <LoadingBeforeViewData />
    }

    if(idAfiliadoTurno && dataAfiliado.id_afiliado.toString() !== idAfiliadoTurno){
        return <LoadingBeforeViewData />
    }
    if(!idAfiliadoTurno && dataAfiliado.id_afiliado !== idAfiliado){
        return <LoadingBeforeViewData />
    }

    return (
        <MiPerfil 
            idUsuario={idUsuario}
            dataAfiliado={dataAfiliado}
            handleResetPassword={handleResetPassword}
            handleChangeDataContacto={handleChangeDataContacto}
            idAfiliado={idAfiliadoTurno ? idAfiliadoTurno : idAfiliado}
        />
    )
}

export default MiPerfilContainer
